import {
  useRecordContext,
  RecordContextProvider,
  NumberField,
  DateField,
} from "react-admin";
import Box from "@mui/material/Box";

const SalesmanPenaltyDetailExpandList = () => {
  const record = useRecordContext();
  const details = Array.isArray(record?.details) ? record.details : [];

  return (
    <Box
      sx={{
        m: 4,
        backgroundClip: "padding-box",
        boxShadow: (theme) => {
          return theme.components.MuiPaper
            ? theme.components.MuiPaper.styleOverrides.elevation1.boxShadow
            : undefined;
        },
        borderRadius: "4px",
        bgcolor: "background.paper",
      }}
    >
      <Box
        component="table"
        sx={{
          width: "100%",
          borderCollapse: "collapse",
          "& th, td": {
            padding: "4px 8px",
            border: "1px solid #dddddd",
          },
        }}
      >
        <thead>
          <tr>
            <th>Tgl SJ</th>
            <th>No SJ</th>
            <th style={{ textAlign: "right" }}>Total SJ</th>
            <th>Pelanggan</th>
            <th>Tgl Bukti</th>
            <th>No Bukti</th>
            <th>Bank</th>
            <th>Tgl Cair</th>
            <th style={{ textAlign: "right" }}>Hari</th>
            <th style={{ textAlign: "right" }}>Total Bayar</th>
            <th style={{ textAlign: "right" }}>Ret/Pot</th>
            <th style={{ textAlign: "right" }}>{"<=90"}</th>
            <th style={{ textAlign: "right" }}>{">90 <=120"}</th>
            <th style={{ textAlign: "right" }}>{">120"}</th>
          </tr>
        </thead>
        <tbody>
          {details.map((detail, idx) => (
            <tr key={detail.id + idx}>
              <td>
                <RecordContextProvider value={detail}>
                  <DateField
                    source="sj_date"
                    options={{
                      year: "numeric",
                      month: "short",
                      day: "2-digit",
                    }}
                    sx={{ fontSize: "inherit" }}
                  />
                </RecordContextProvider>
              </td>
              <td>{detail.sj_code}</td>
              <td style={{ textAlign: "right" }}>
                <RecordContextProvider value={detail}>
                  <NumberField
                    source="sj_total"
                    sx={{
                      fontSize: "inherit",
                    }}
                  />
                </RecordContextProvider>
              </td>
              <td>{detail.customer_name}</td>
              <td>
                <RecordContextProvider value={detail}>
                  <DateField
                    source="receipt_date"
                    options={{
                      year: "numeric",
                      month: "short",
                      day: "2-digit",
                    }}
                    sx={{ fontSize: "inherit" }}
                  />
                </RecordContextProvider>
              </td>
              <td>{detail.receipt_code}</td>
              <td>{detail.bank}</td>
              <td>
                <RecordContextProvider value={detail}>
                  <DateField
                    source="cashing_date"
                    options={{
                      year: "numeric",
                      month: "short",
                      day: "2-digit",
                    }}
                    sx={{ fontSize: "inherit" }}
                  />
                </RecordContextProvider>
              </td>
              <td style={{ textAlign: "right" }}>{detail.days}</td>
              <td style={{ textAlign: "right" }}>
                <RecordContextProvider value={detail}>
                  <NumberField
                    source="total_payment"
                    sx={{
                      fontSize: "inherit",
                    }}
                  />
                </RecordContextProvider>
              </td>
              <td style={{ textAlign: "right" }}>
                <RecordContextProvider value={detail}>
                  <NumberField
                    source="ret_pot"
                    sx={{
                      fontSize: "inherit",
                    }}
                  />
                </RecordContextProvider>
              </td>
              <td style={{ textAlign: "right" }}>
                <RecordContextProvider value={detail}>
                  <NumberField
                    source="penalty_lte_90"
                    sx={{
                      fontSize: "inherit",
                    }}
                  />
                </RecordContextProvider>
              </td>
              <td style={{ textAlign: "right" }}>
                <RecordContextProvider value={detail}>
                  <NumberField
                    source="penalty_gt_90_lte_120"
                    sx={{
                      fontSize: "inherit",
                    }}
                  />
                </RecordContextProvider>
              </td>
              <td style={{ textAlign: "right" }}>
                <RecordContextProvider value={detail}>
                  <NumberField
                    source="penalty_gt_120"
                    sx={{
                      fontSize: "inherit",
                    }}
                  />
                </RecordContextProvider>
              </td>
            </tr>
          ))}
        </tbody>
      </Box>
    </Box>
  );
};

export default SalesmanPenaltyDetailExpandList;
